export default (Vue , options = {})=>{
    //Vue 指令最终的方法
    const addListener = (ele,binding) =>{
        if (binding.value) {
            if (ele.children.length) {
                Array.from(ele.children).forEach(elem=>{
                    if (!elem.classList.contains('skeleton')) {
                        elem.classList.add('skeleton')
                    }
                });
            }else if (!ele.classList.contains('skeleton')) {
                ele.classList.add('skeleton')
            }
            
        } else {
            if (ele.children.length) {
                Array.from(ele.children).forEach(elem=>{
                    if (!elem.classList.contains('skeleton')) {
                        elem.classList.remove('skeleton')
                    }
                });
            } else {
                ele.classList.remove("skeleton");
            }
            
        }
    }

    Vue.directive('skeleton',{
        inserted:addListener,
        update:addListener
    })
}